import { render, staticRenderFns } from "./CompanyAdminOrderCancelButton.vue?vue&type=template&id=a0c0eab2&"
import script from "./CompanyAdminOrderCancelButton.vue?vue&type=script&lang=js&"
export * from "./CompanyAdminOrderCancelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports